import React, { useRef } from 'react'
import s from './Route.less'
import GoToRoadbookButton from './GoToRoadbookButton'
import ProviderCTAButton from './ProviderCTAButton'
import GPSButton from './GPSButton'
import RouteLabelComponents from './RouteLabelComponents'
import classNames from 'classnames'
import { useAction } from '../utils/react-redux'
import useEventCallback from '../utils/useEventCallback'
import RouteMainInformations from './RouteMainInformations'
import RouteOptional from './RouteOptional'
import { navigateToItineraryRoute } from '../../store/itinerary/itinerary.actions'
import ShareItineraryRouteButton from './shareToMobile/ShareItineraryRouteButton'
import ShareItineraryPopin from './shareToMobile/ShareItineraryPopin'
import { CLICKED_BUTTON } from '../analytics/analytics.constants'

const propagateParentClickEvent = (...refs) => {
  let tagSent = false
  refs
    .filter((ref) => ref?.current)
    .forEach((ref) => {
      if (ref?.current?.dataset?.[CLICKED_BUTTON]) {
        const initialDataSetValue = ref.current.dataset[CLICKED_BUTTON]
        ref.current.dataset[CLICKED_BUTTON] = 'bloc'
        if (tagSent) ref.current.dataset['tagDisabled'] = 'true'
        ref.current?.click?.()
        tagSent = true
        ref.current.dataset[CLICKED_BUTTON] = initialDataSetValue
        delete ref.current.dataset['tagDisabled']
      } else {
        ref.current?.click?.()
      }
    })
}

const Route = ({ route, selected, selectedRouteDomRef }) => {
  const goToRoadbookBtnRef = useRef()
  const providerCTABtnRef = useRef()
  const gpsBtnRef = useRef()

  const execNavigateToRoute = useAction(navigateToItineraryRoute)

  const onClick = useEventCallback(() => {
    if (selected) {
      propagateParentClickEvent(goToRoadbookBtnRef, providerCTABtnRef, gpsBtnRef)
    } else {
      execNavigateToRoute(
        {
          routeId: route.routeId,
          provider: route.provider,
        },
        { avoidSendPageTag: true }
      )
    }
  })

  if (route.isOptional) return <RouteOptional route={route} />

  const displayState = selected ? 'expanded' : 'condensed'

  return (
    <li
      ref={selected ? selectedRouteDomRef : null}
      className={classNames(s.route, !selected && s.condensed)}
      onClick={onClick}
    >
      <div className={s.routeTitle}>
        <RouteLabelComponents components={route.title.components} />
      </div>
      {(route.labels?.[displayState] ?? []).map((label, index) => (
        <div className={s.routeLabel} key={index}>
          <RouteLabelComponents components={label.components} backgroundColor={label?.background_color} />
        </div>
      ))}
      <div className={s.routeListButtons}>
        {selected && (
          <>
            {route.roadbookLink && (
              <GoToRoadbookButton className={s.routeListButton} elementRef={goToRoadbookBtnRef} route={route} />
            )}
            {route.ctaLink && (
              <ProviderCTAButton
                className={s.routeListButton}
                elementRef={providerCTABtnRef}
                route={route}
                placement="listeresultat"
              />
            )}
            {!route.ctaLink && <ShareItineraryRouteButton className={s.routeListButton} route={route} />}
            <ShareItineraryPopin />
            {route.gps && <GPSButton className={s.routeListButton} elementRef={gpsBtnRef} gpsInfo={route.gps} />}
          </>
        )}
      </div>
      <RouteMainInformations route={route} selected={selected} />
    </li>
  )
}

export default Route
